"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lightenDarkenHexColor = exports.withLightness = exports.rgbToHsl = exports.hslaImpl = exports.hueToRgb = exports.mixColor = exports.toRgb = exports.colorEquals = exports.colorLightness = exports.isHexColor = exports.hexToRgbA = exports.hexToRgbArray = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var hexToRgbArray = function hexToRgbArray(hex) {
  var c;

  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');

    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }

    c = '0x' + c.join('');
    var r = c >> 16 & 255;
    var g = c >> 8 & 255;
    var b = c & 255;
    return [r, g, b];
  }

  throw new Error('Bad Hex');
}; // http://stackoverflow.com/questions/21646738/convert-hex-to-rgba

/**
 * Convert a hex color to rgba
 *
 * @param {string} hex - hex color (#fbafff)
 * @param {number} opacity - optional, amount of opacity 0-1
 *
 */


exports.hexToRgbArray = hexToRgbArray;

var hexToRgbA = function hexToRgbA(hex) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  opacity = opacity <= 1 && opacity >= 0 ? opacity : 1; // value should be between 0 & 1, otherwise, default to 1

  var _hexToRgbArray = hexToRgbArray(hex),
      _hexToRgbArray2 = (0, _slicedToArray2["default"])(_hexToRgbArray, 3),
      r = _hexToRgbArray2[0],
      g = _hexToRgbArray2[1],
      b = _hexToRgbArray2[2];

  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
};
/**
 * Checks if a string is valid hex color value
 *
 * @param {string} hex - hex color string
 */


exports.hexToRgbA = hexToRgbA;

var isHexColor = function isHexColor(value) {
  if (value) {
    var hex = value.trim();
    var regex = new RegExp('^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$');
    return regex.test(hex);
  }

  return false;
};

exports.isHexColor = isHexColor;

var colorLightness = function colorLightness(cl) {
  return 0.299 * cl[0] / 255 + 0.587 * cl[1] / 255 + 0.114 * cl[2] / 255;
};

exports.colorLightness = colorLightness;

var colorEquals = function colorEquals(c1, c2) {
  return c1 && c2 && c1.length === c2.length && c1.length === 3 && c1[0] === c2[0] && c1[1] === c2[1] && c1[2] === c2[2];
};

exports.colorEquals = colorEquals;

var toRgb = function toRgb(color) {
  return "rgb(".concat(color.join(','), ")");
};

exports.toRgb = toRgb;

var mixColor = function mixColor(color1, color2, amount) {
  return color1.map(function (c, i) {
    return parseInt(c + (color2[i] - c) * amount);
  });
};

exports.mixColor = mixColor;

var hueToRgb = function hueToRgb(m1, m2, h) {
  while (h < 0) {
    h += 1;
  }

  while (h > 1) {
    h -= 1;
  }

  if (h * 6.0 < 1) {
    return m1 + (m2 - m1) * h * 6;
  }

  if (h * 2.0 < 1) {
    return m2;
  }

  if (h * 3.0 < 2) {
    return m1 + (m2 - m1) * (2.0 / 3.0 - h) * 6;
  }

  return m1;
};

exports.hueToRgb = hueToRgb;

var hslaImpl = function hslaImpl(h, s, l, a) {
  h /= 360.0;
  s /= 100.0;
  l /= 100.0;

  if (l < 0) {
    l = 0;
  }

  if (s < 0) {
    s = 0;
  }

  if (l > 1) {
    l = 1;
  }

  if (s > 1) {
    s = 1;
  }

  while (h < 0) {
    h += 1;
  }

  while (h > 1) {
    h -= 1;
  } // if saturation is exacly zero, we loose
  // information for hue, since it will evaluate
  // to zero if converted back from rgb. Setting
  // saturation to a very tiny number solves this.


  if (s === 0) {
    s = 1e-10;
  } // Algorithm from the CSS3 spec: http://www.w3.org/TR/css3-color/#hsl-color.


  var m2;

  if (l <= 0.5) {
    m2 = l * (s + 1.0);
  } else {
    m2 = l + s - l * s;
  }

  var m1 = l * 2.0 - m2; // round the results

  var r = hueToRgb(m1, m2, h + 1.0 / 3.0) * 255.0;
  var g = hueToRgb(m1, m2, h) * 255.0;
  var b = hueToRgb(m1, m2, h - 1.0 / 3.0) * 255.0;
  return [parseInt(r), parseInt(g), parseInt(b), a];
};

exports.hslaImpl = hslaImpl;

var rgbToHsl = function rgbToHsl(r, g, b) {
  // Algorithm from https://en.wikipedia.org/wiki/HSL_and_HSV#From_HSL
  r /= 255.0;
  g /= 255.0;
  b /= 255.0;
  var max = Math.max(r, Math.max(g, b));
  var min = Math.min(r, Math.min(g, b));
  var delta = max - min;
  var h = 0;
  var s;
  var l = (max + min) / 2.0;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    if (l < 0.5) {
      s = delta / (max + min);
    } else {
      s = delta / (2.0 - max - min);
    }

    if (r === max) {
      h = (g - b) / delta + (g < b ? 6 : 0);
    } else if (g === max) {
      h = (b - r) / delta + 2;
    } else if (b === max) {
      h = (r - g) / delta + 4;
    }
  }

  return [h / 6 * 360, s * 100, l * 100];
};

exports.rgbToHsl = rgbToHsl;

var withLightness = function withLightness(color, lightness, saturationModifier) {
  var hsl = rgbToHsl.apply(void 0, (0, _toConsumableArray2["default"])(color));
  var hslcolorL = hsl[2];

  if (hslcolorL < 0) {
    hslcolorL = 0;
  }

  return hslaImpl(hsl[0], hsl[1] * saturationModifier, lightness, 1);
};
/**
 * This function will lighten or darken a hex-color by the percentage you provide.
 * A negative value will darken the provided color, where a positive value will lighten it.
 *
 * @param {*} color A hexadecimal color like #FFFFFF
 * @param {*} percent The amount you want to lighten/darken the color by.
 */


exports.withLightness = withLightness;

var lightenDarkenHexColor = function lightenDarkenHexColor(color, percent) {
  var _hexToRgbArray3 = hexToRgbArray(color),
      _hexToRgbArray4 = (0, _slicedToArray2["default"])(_hexToRgbArray3, 3),
      r = _hexToRgbArray4[0],
      g = _hexToRgbArray4[1],
      b = _hexToRgbArray4[2];

  var _rgbToHsl = rgbToHsl(r, g, b),
      _rgbToHsl2 = (0, _slicedToArray2["default"])(_rgbToHsl, 3),
      h = _rgbToHsl2[0],
      s = _rgbToHsl2[1],
      l = _rgbToHsl2[2];

  var adjustmentValue = l / 100 * Math.abs(percent);
  var lighting = percent < 0 ? l - adjustmentValue : l + adjustmentValue;
  return "hsl(".concat(h, ", ").concat(s, "%, ").concat(lighting, "%)");
};

exports.lightenDarkenHexColor = lightenDarkenHexColor;